import React, {useMemo, useState} from 'react';
import useI18n from 'i18n/useI18n';
import styled from 'styled-components';
import { PRIMARY, INPUTS } from '@etiquette-ui/colors';

const DaysTranslation = {
  en: {
    SUNDAY: 'Sunday',
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
  },
  es: {
    SUNDAY: 'Domingo',
    MONDAY: 'Lunes',
    TUESDAY: 'Martes',
    WEDNESDAY: 'Miércoles',
    THURSDAY: 'Jueves',
    FRIDAY: 'Viernes',
    SATURDAY: 'Sábado',
  }
}

const Container = styled.div`
  .label {
    font-size: 14px;
    font-weight: 500;
    margin-top: -3px;
    margin-bottom: 7px;
    color: ${PRIMARY};
  }
`;
const DaysRow = styled.div`
  display: flex;
`;
const DayOption = styled.div`
  width: 38px;
  height: 30px;
  display: flex;
  font-size: 12px;
  margin-right: 5px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  background-color: ${({isActive}) => !!isActive ? PRIMARY : INPUTS};
`;

const DaysSelector = ({ selectedDays=[], onChange, containerClassName }) => {
  const { translateObject, translate, selectedLang } = useI18n();
  const [dayIndexes, setDayIndexes] = useState(selectedDays);

  const daysOptions = useMemo(()=>{
    return Object.entries(translateObject(DaysTranslation)).map( ([key,value]) => ({
      value: key,
      label: value[0]
    }));
  }, [selectedLang, selectedDays]);

  const onClick = ( dayIndex ) => {
    let newIndexes = [...dayIndexes];
    if(newIndexes.includes(dayIndex)){      
      const currentIndex = newIndexes.indexOf(dayIndex);
      newIndexes.splice(currentIndex, 1);
      setDayIndexes(newIndexes);
    } else {
      newIndexes = [...newIndexes, dayIndex];
      setDayIndexes( newIndexes );
    }
    onChange(newIndexes)
  }

  return (
    <Container className={`${containerClassName}`}>
      <div className='label'>{translate("Days")}</div>
      <DaysRow>
        {!!daysOptions && daysOptions.map( dayOption => (
          <DayOption onClick={()=>onClick(dayOption.value)} isActive={ dayIndexes.includes(dayOption.value) }>
            {dayOption.label}
          </DayOption>
        ))}
      </DaysRow>
    </Container>
  )
}
export default DaysSelector;